import { defineStore } from "pinia";
import {LK} from "@/controllerLK/LKstore";
export const useLK = defineStore({
    ...LK
});